import React from 'react';
import { SectionProps } from '../types';
import useMenu from '../../../../hooks/context/useMenu';
import { StarOutlined } from '@ant-design/icons';
import useHelpers from '../../../../hooks/utility/useHelpers';
import { Client } from '../../../../types/menu';
import useOrderBasket from '../../../../hooks/context/useOrderBasket';
import { SidebarSectionEnum } from '../enums';

const PromotedProducts = ({ ...rest }: SectionProps) => {
  const { promotedProducts } = useMenu();
  const { formatCurrency } = useHelpers();
  const { initItem, openLineItemModal } = useOrderBasket();
  const onAddProduct = (product: Client.Product) => openLineItemModal(initItem(product));

  if (!promotedProducts?.length) {
    return null;
  }

  return (
    <section {...rest} id={SidebarSectionEnum.PromotedProducts}>
      <h4 className="text-md font-semibold text-slate-700">
        <StarOutlined className="text-md mr-2" />
        Most popular dishes
      </h4>
      <div className="grid grid-cols-3 gap-4 justify-evenly">
        {promotedProducts?.map((item) => (
          <button
            onClick={() => onAddProduct(item)}
            className="flex flex-col justify-between"
            key={`promoted-product-${item.id}`}
          >
            <img
              src={item.image_url}
              className="w-full bg-gray-100 rounded-xl object-cover aspect-square"
            />
            <div>
              <p className="mt-xs font-medium text-left break-all">{item.name}</p>
              <p className="mt-xs text-sm text-left text-gray-950">{formatCurrency(item.price)}</p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default PromotedProducts;
